import * as React from 'react';
export const familymartSvg = React.forwardRef(function familymartSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M15 7.719H1V3h14v4.719ZM1 13h14V8.388H1V13Z',
    }),
  );
});
familymartSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var familymart = {
  category: 'paymentmethod',
  colorable: true,
  name: 'familymart',
  svg: familymartSvg,
};
